import "./assets/js/app"; // メインJS
import "./assets/sass/style.scss"; // メインCSS

import Swiper from "swiper";
import { Navigation, Autoplay } from "swiper/modules";

const mySwiper = new Swiper('.sec-slider .swiper', {
    modules: [Navigation, Autoplay],
    speed: 1000,
    slidesPerView: 1,
    spaceBetween: 20,
    grabCursor: true,
    loop: true,
    loopAdditionalSlides: 1,
    autoplay: {
        delay: 4000,
        disableOnInteraction: true,
    },
    navigation: {
        nextEl: '.sec-slider .swiper-button-next',
        prevEl: '.sec-slider .swiper-button-prev',
    },
    breakpoints: {
        600: {
        slidesPerView: 2,
        },
        1025: {
        slidesPerView: 4,
        spaceBetween: 20,
        }
    },
});

function cbName(entries) {
    entries.forEach( entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add("active");
        // } else {
        //     entry.target.classList.remove("active");
        }
    });
}
const animas = document.querySelectorAll('.anima');
const options = {
    root: null,
    rootMargin: "0% 0%",
    threshold: 0
};

const observer = new IntersectionObserver(cbName,options);
animas.forEach(anima => {
    observer.observe(anima);
});
